export default "__VITE_ASSET__BK5a9Mkv__"